import { TextField } from "@mui/material"
const Input = ({name, label, multiline = false, value, handleOnChange, index}) =>{
    return <TextField 
        id={name} 
        label={label} 
        multiline={multiline}
        value={value}
        onChange={(e)=>handleOnChange(name, e.target.value, index)}
        rows={6}
        variant="outlined" 
        fullWidth />
}

export default Input
